// extracted by mini-css-extract-plugin
export var container = "DigitalWalkInBooking-module--container--763fa";
export var cta = "DigitalWalkInBooking-module--cta--fcf7e";
export var root = "DigitalWalkInBooking-module--root--585cd";
export var text = "DigitalWalkInBooking-module--text--002ba";
export var title = "DigitalWalkInBooking-module--title--a882d";